'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styled = require('styled-components');
require('../../enums/accordion.js');
require('../../enums/alert.js');
require('../../enums/avatar.js');
require('../../enums/breakpoints.js');
var button = require('../../enums/button.js');
require('../../enums/code-editor.js');
require('../../enums/colors.js');
require('../../enums/combobox.js');
require('../../enums/date.js');
require('../../enums/drag-and-drop.js');
require('../../enums/dialog.js');
require('../../enums/divider.js');
require('../../enums/dropdown.js');
require('../../enums/fieldset.js');
require('../../enums/font-icon.js');
require('../../enums/fonts.js');
require('../../enums/headings.js');
require('../../enums/input.js');
require('../../enums/keys.js');
require('../../enums/list.js');
require('../../enums/listbox.js');
require('../../enums/loader.js');
require('../../enums/margin.js');
require('../../enums/option.js');
require('../../enums/pill.js');
require('../../enums/placements.js');
require('../../enums/popout.js');
require('../../enums/privacy.js');
require('../../enums/radio-group.js');
require('../../enums/status.js');
require('../../enums/switch.js');
require('../../enums/table.js');
require('../../enums/tooltip.js');
require('../../enums/transitions.js');
require('../../enums/widths.js');
require('../../themes/alert.js');
var borders = require('../../themes/borders.js');
require('../../themes/button.js');
require('../../themes/checkbox.js');
require('../../themes/divider.js');
require('../../themes/dropdown.js');
require('../../themes/fieldset.js');
var fonts = require('../../themes/fonts.js');
require('../../themes/input.js');
require('../../themes/list.js');
require('../../themes/listbox.js');
require('../../themes/loader.js');
require('../../themes/option.js');
require('../../themes/popout.js');
require('../../themes/switch.js');
require('../../themes/themes.js');
require('../../themes/tooltip.js');
var mediaQueries = require('./media-queries.js');

const baseButtonStyle = styled.css`
  align-items: center;
  appearance: none;
  background-color: transparent;
  border-color: transparent;
  border-radius: ${borders.borderRadiusMedium}px;
  border-style: solid;
  border-width: 1px;
  box-sizing: border-box;
  color: #000;
  cursor: pointer;
  display: inline-flex;
  flex-direction: row;
  flex-shrink: 0;
  font-family: ${fonts.fontFamilyBook};
  font-size: 14px;
  justify-content: center;
  line-height: 22px;
  min-height: 50px;
  padding: 13px 20px;
  text-decoration: none;
  transition:
    background-color 0.2s ease,
    border-color 0.2s ease,
    color 0.2s ease,
    outline 0.1s ease;
  vertical-align: top;
  ${mediaQueries.mediaPrefersReducedMotion}

  &:focus {
    outline: 0;
  }

  &:focus-visible {
    outline-color: #000;
    outline-offset: ${({ theme  })=>`${theme.outline.offset}px`};
    outline-style: ${({ theme  })=>theme.outline.style};
    outline-width: ${({ theme  })=>`${theme.outline.width}px`};
  }

  &[aria-disabled='true'] {
    cursor: not-allowed;
  }
`;
const iconButtonStyle = styled.css`
  align-items: center;
  appearance: none;
  background-color: transparent;
  border-color: transparent;
  border-radius: ${borders.borderRadiusMedium}px;
  border-style: solid;
  border-width: 1px;
  box-sizing: border-box;
  cursor: pointer;
  display: inline-flex;
  flex-direction: row;
  flex-shrink: 0;
  justify-content: center;
  padding: 10px;
  text-decoration: none;
  transition:
    background-color 0.2s ease,
    border-color 0.2s ease,
    color 0.2s ease,
    outline 0.1s ease;
  vertical-align: top;
  ${mediaQueries.mediaPrefersReducedMotion}

  &:focus {
    outline: 0;
  }

  &:focus-visible {
    outline-color: transparent;
    outline-offset: ${({ theme  })=>`${theme.outline.offset}px`};
    outline-style: ${({ theme  })=>theme.outline.style};
    outline-width: ${({ theme  })=>`${theme.outline.width}px`};
  }

  &[aria-disabled='true'] {
    cursor: not-allowed;
  }
`;
/**
 * Get Styled Component button theme
 * @param options GetButtonThemeOptions
 * @returns ThemedCssFunction<DefaultTheme>
 */ const getButtonTheme = (options)=>{
    const { look  } = options;
    return styled.css`
    background-color: ${({ theme  })=>theme.button[look].backgroundColor};
    border-color: ${({ theme  })=>theme.button[look].borderColor};
    color: ${({ theme  })=>theme.button[look].textColor};

    &:hover {
      background-color: ${({ theme  })=>theme.button[look].backgroundColorHover};
      border-color: ${({ theme  })=>theme.button[look].borderColorHover};
      color: ${({ theme  })=>theme.button[look].textColorHover};
    }

    &:active {
      background-color: ${({ theme  })=>theme.button[look].backgroundColorActive};
      border-color: ${({ theme  })=>theme.button[look].borderColorActive};
      color: ${({ theme  })=>theme.button[look].textColorActive};
    }

    &:focus-visible {
      background-color: ${({ theme  })=>theme.button[look].backgroundColorFocus};
      border-color: ${({ theme  })=>theme.button[look].borderColorFocus};
      color: ${({ theme  })=>theme.button[look].textColorFocus};
      outline-color: ${({ theme  })=>theme.button[look].outlineColorFocus};
    }

    &[aria-disabled='true'] {
      background-color: ${({ theme  })=>theme.button[look].backgroundColorDisabled};
      border-color: ${({ theme  })=>theme.button[look].borderColorDisabled};
      color: ${({ theme  })=>theme.button[look].textColorDisabled};
    }

    &[aria-expanded='true'] {
      background-color: ${({ theme  })=>theme.button[look].backgroundColorHover};
      border-color: ${({ theme  })=>theme.button[look].borderColorHover};
      color: ${({ theme  })=>theme.button[look].textColorHover};
    }
  `;
};
/**
 * Get Styled Component button theme
 * @param options GetButtonWidthOptions
 * @returns ThemedCssFunction<DefaultTheme>
 */ const getButtonWidth = (options)=>{
    const { fullWidth , size  } = options;
    if (fullWidth) {
        return styled.css`
      width: 100%;
    `;
    } else switch(size){
        case button.ButtonSizes.Large:
            {
                return styled.css`
          min-width: 225px;
        `;
            }
        case button.ButtonSizes.Medium:
            {
                return styled.css`
          min-width: 175px;
        `;
            }
        case button.ButtonSizes.Small:
            {
                return styled.css`
          min-width: 125px;
        `;
            }
        case button.ButtonSizes.XSmall:
            {
                return styled.css`
          min-width: 75px;
        `;
            }
    }
    return '';
};

exports.baseButtonStyle = baseButtonStyle;
exports.getButtonTheme = getButtonTheme;
exports.getButtonWidth = getButtonWidth;
exports.iconButtonStyle = iconButtonStyle;
//# sourceMappingURL=button.js.map
